import React, {createContext, useCallback, useEffect, useState} from 'react';
import api, {clearAccessToken, restoreStaffSession} from '../utils/api';

const UserContext = createContext();

const UserProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const logoutUser = useCallback(async () => {
        try { await api.post('/v1/staff/auth/logout'); } catch (_) {}
        clearAccessToken();
        setUser(null);
    }, []);

    useEffect(() => {
        restoreStaffSession().then(setUser).catch(() => setUser(null)).finally(() => setLoading(false));
        const expired = () => { clearAccessToken(); setUser(null); };
        window.addEventListener('staff-session-expired', expired);
        return () => window.removeEventListener('staff-session-expired', expired);
    }, []);

    const loginUser = (value) => setUser(value);
    const updateUserProfile = (profile) => setUser(current => ({...current, ...profile}));
    return <UserContext.Provider value={{user, loading, loginUser, logoutUser, updateUserProfile}}>{children}</UserContext.Provider>;
};

export {UserContext, UserProvider};
